APP_CONTAINER_VERSION = '12.41.0';
APP_CORE_VERSION = '12.65.0';
APP_CONTAINER_NAME = 'self-digital-fe';
APP_CORE_NAME = 'self-digital-core-fe';
